'use strict';

/**
 * @file 百度统计信息类
 * @author zhangzhe(zhangzhe@baidu.com)
 */

define(['version', 'utils/helpers'], function (version, utils) {

    var authOnlineUrl = 'https://drm.media.baidubce.com/v1/playerAuth';

    var certifyCallBack = function certifyCallBack(result) {
        // 如果鉴权失败
        if (result.code && (result.code === 'UNAUTHORIZED' || result.code === 'BAD_REQUEST')) {
            showCertifyWarning();
        }
    };

    function showCertifyWarning() {
        var warningDivs = utils.getElementsByClassName('jw-warning');
        for (var i = 0; i < warningDivs.length; i++) {
            var warningDiv = warningDivs[i];
            warningDiv.style.display = 'block';
        }
    }

    var Log = function Log(config, api) {
        this.config = config;
        this.api = api;
    };

    Log.prototype = {
        userCertify: function userCertify() {
            if (__DEBUG__ || this.config.withLog === false) {
                return false;
            }
            var ak = this.config.ak ? this.config.ak : '';
            if (!/^[a-zA-Z0-9]{32}$/.test(ak)) {
                showCertifyWarning();
                return false;
            }
            var player = 'web-html5-' + version;
            var browserInfo = utils.getBrowserInfo();
            var url = authOnlineUrl + '?ak=' + ak + '&player=' + player + '&platform=' + browserInfo + '&callback=' + this._getCallback();
            url = encodeURI(url);
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            document.getElementsByTagName('head')[0].appendChild(script);
        },

        _getCallback: function _getCallback() {
            var now = new Date().getTime();
            var seed = Math.random() * 1e9 >>> 0;
            var callbackName = 'jwplayer_' + now + '_' + seed;
            window[callbackName] = function (result) {
                try {
                    certifyCallBack(result);
                    delete window[callbackName];
                } catch (ex) {
                    window[callbackName] = null;
                }
            };
            return callbackName;
        }
    };

    return Log;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/baidu/log.js
 ** module id = 213
 ** module chunks = 0
 **/